import { useState, useEffect, useCallback } from "react";
import PortfolioGrid from "./PortfolioGrid";
import { supabase } from "@/lib/supabase";
import { RefreshCw } from "lucide-react";

const Portfolio = () => {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [fetchError, setFetchError] = useState(false);

  const fetchProjects = useCallback(async () => {
    setLoading(true);
    setFetchError(false);
    const { data, error } = await supabase
      .from('Project')
      .select('*')
      .order('createdAt', { ascending: false });

    if (error || !data) {
      setFetchError(true);
    } else {
      setProjects(data as any);
    }
    setLoading(false);
  }, []);

  useEffect(() => {
    fetchProjects();
  }, [fetchProjects]);

  if (loading) {
    return (
      <div className="h-64 flex items-center justify-center">
        <div className="flex flex-col items-center gap-4 text-text-muted">
          <div className="w-8 h-8 border-2 border-primary border-t-transparent rounded-full animate-spin" />
          <span className="text-sm">Loading projects...</span>
        </div>
      </div>
    );
  }

  if (fetchError) {
    return (
      <div className="h-64 flex flex-col items-center justify-center gap-4 text-text-muted">
        <p className="text-sm">Could not load projects. Please try again.</p>
        <button
          onClick={fetchProjects}
          className="flex items-center gap-2 px-4 py-2 rounded-lg bg-white/5 border border-white/10 text-sm hover:bg-white/10 transition-colors"
        >
          <RefreshCw size={14} /> Retry
        </button>
      </div>
    );
  }

  return <PortfolioGrid projects={projects} />;
};

export default Portfolio;
